import { render, staticRenderFns } from "./workDepartment.vue?vue&type=template&id=2d7205f0&scoped=true"
import script from "./workDepartment.vue?vue&type=script&lang=js"
export * from "./workDepartment.vue?vue&type=script&lang=js"
import style0 from "./workDepartment.vue?vue&type=style&index=0&id=2d7205f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7205f0",
  null
  
)

export default component.exports